import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import {
  humanFileSize,
  uploadShapes
} from '../../actions/shapeSets/uploadHelpers';

export default class ShapeSetShapes extends React.Component {
  static displayName = 'ShapeSetShapes';

  constructor(props) {
    super(props);
    this.onDrop = this.onDrop.bind(this);
    this.uploadFiles = this.uploadFiles.bind(this);

    this.state = { files: [] };
  }

  componentDidMount() {
    const { currentShapeSet, params: { shapeSetId, context } } = this.props;

    if (currentShapeSet.refName) {
      this.props
        .getDownloadUrl(shapeSetId, context)
        .then(
          success => {},
          error => console.log("couldn't get download link")
        );
    }

    this.screenReaderContent.focus();
  }

  onDrop(acceptedFiles, rejectedFiles) {
    this.setState({ files: acceptedFiles, successMsg: false });
    const errorMsg = rejectedFiles.length
      ? 'Only .zip files can be uploaded.'
      : undefined;
    this.setState({ errorMsg: errorMsg });
  }

  uploadFiles() {
    this.setState({ uploading: true });
    const token = this.props.authentication.token;
    const { shapeSetId, context } = this.props.params;
    const organisationId = this.currentOrgId();
    uploadShapes(this.state.files, token, shapeSetId, organisationId).then(
      response => {
        const currentOrganisationId = this.props.currentOrganisation
          ? this.props.currentOrganisation.id
          : undefined;
        Promise.all([
          this.props.updateCurrentShapeSet(shapeSetId, context),
          this.props.getDownloadUrl(shapeSetId, context),
          // get locations for currentOrg because we may have uploaded more
          this.props.getOrganisations(currentOrganisationId)
        ]).then(success => {
          this.setState({
            uploading: false,
            files: [],
            successMsg: true
          });
        });
      },
      error => {
        const errorMsg =
          error.data.message || 'Something went wrong, please try again later.';
        this.setState({
          uploading: false,
          files: [],
          errorMsg
        });
      }
    );
  }

  currentOrgId = () => {
    const context = this.props.params.context;

    switch (context) {
      case 'customer':
        return this.props.currentOrganisation.id;
      case 'sub-account':
        return this.props.currentLocation.id;
      default:
        return undefined;
    }
  };

  render() {
    const { currentShapeSet, params: { context } } = this.props;
    const canEdit = currentShapeSet.isOwner || context === 'global';
    return (
      <div>
        <Row />
        <h3
          className="screen-reader-only"
          tabIndex="-1"
          ref={i => (this.screenReaderContent = i)}
        >
          Showing catchment files for catchment set {currentShapeSet.name}
        </h3>

        {currentShapeSet && (
          <div>
            <Row>
              <Col sm={12}>
                <p>
                  <strong>Current catchment file:</strong>
                </p>
                <Row className="current-shapefile">
                  <Col sm={6} md={8}>
                    <p>
                      {currentShapeSet.refName || 'No catchment file uploaded'}
                    </p>
                  </Col>
                  <Col sm={6} md={4}>
                    <p className="text-right">
                      {canEdit &&
                        currentShapeSet.downloadUrl && (
                          <a href={currentShapeSet.downloadUrl} target="_blank">
                            Download
                          </a>
                        )}
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
            <hr />
          </div>
        )}

        {canEdit && (
          <Row>
            <Col sm={12}>
              <div className="dropzone">
                <Dropzone
                  ref={node => {
                    this.dropzone = node;
                  }}
                  accept="application/zip, application/x-compressed, application/x-zip-compressed, multipart/x-zip"
                  onDrop={this.onDrop}
                  multiple={false}
                >
                  <div className="dropzone-label">
                    Click here, or Drag & Drop your Catchment Set files here to
                    start uploading
                  </div>
                </Dropzone>
              </div>
            </Col>
            <Col sm={12}>
              {this.state.successMsg && (
                <p className="text-success">
                  <strong className="text-success">Success! </strong>
                  Your catchments have been successfully uploaded.
                </p>
              )}
              {this.state.errorMsg && (
                <p className="text-danger">
                  <strong className="text-danger">Error! </strong>
                  {this.state.errorMsg}
                </p>
              )}
            </Col>
          </Row>
        )}
        {this.state.files.length > 0 && (
          <Row>
            <Col sm={12}>
              <p>
                <strong>Files to upload:</strong>
              </p>
              {this.state.files.map(file => (
                <Row key={file.preview} className="file-to-upload">
                  <Col sm={10}>
                    <p>{file.name}</p>
                  </Col>
                  <Col sm={2}>
                    <p>{humanFileSize(file.size)}</p>
                  </Col>
                </Row>
              ))}
            </Col>
            <Col sm={2} className="form-input">
              <Button
                bsStyle="primary"
                type="submit"
                className="relative-padding"
                onClick={this.uploadFiles}
                disabled={this.state.uploading}
              >
                {this.state.uploading ? 'Uploading' : 'Upload'}
              </Button>
            </Col>
            <Col sm={12}>
              {this.state.uploading && (
                <div>
                  <p>
                    Please wait while your files upload. This may take some
                    time.
                  </p>
                  <p>
                    <strong>
                      Please do not refresh your browser or navigate away from
                      this page.
                    </strong>
                  </p>
                </div>
              )}
            </Col>
          </Row>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/shapeset/ShapeSetShapes.js